export class BaseEnum<T = string> {
  readonly name: string;
  readonly value: T;
  constructor(value: T, name: string) {
    this.name = name;
    this.value = value;
  }
  static findByValue = function <F extends BaseEnum<F['value']>, K extends F['value']>(
    this: new (...args: any) => F,
    value?: K,
  ): F | undefined {
    return Object.values(this)
      .filter((obj) => obj instanceof BaseEnum)
      .find((obj) => {
        return obj.value === value;
      }) as F;
  };

  static findByName = function <F extends BaseEnum>(this: new (...args: any) => F, name?: string): F | undefined {
    return Object.values(this)
      .filter((obj) => obj instanceof BaseEnum)
      .find((obj) => {
        return obj.name === name;
      }) as F;
  };

  static findEnums = function <F extends BaseEnum>(this: new (...args: any) => F): F[] {
    return Object.values(this).filter((obj) => obj instanceof BaseEnum) as F[];
  };

  static findEnumValues = function <F extends BaseEnum>(this: new (...args: any) => F): Record<string, string> {
    const list = Object.values(this).filter((obj) => obj instanceof BaseEnum) as F[];
    return list.reduce((res, item) => {
      return { ...res, [item.value]: item.name };
    }, {});
  };
}
